module.exports = __webpack_public_path__ + "static/media/marker.98930f0b.png";